<template>
  <div>
    <header>
      <div class="navbar">
        <a
          href="#"
          class="navbar-brand"
        ><img src="@/assets/images/landing/pick8_logo.png"></a>
        <nav class="navbar-navigation">
          <div class="actions">
            <router-link
              :to="{name: 'login'}"
              tag="a"
              class="login mr-2"
            >
              登陆
            </router-link>
            <router-link
              :to="{name: 'register'}"
              tag="a"
              class="sign-up register1"
            >
              注册
            </router-link>
          </div>
        </nav>
      </div>
    </header>
    <!-- Slider -->
    <div
      class="slideconteiner"
      :style="{ 'background-image': 'url(' + require('@/assets/images/landing/slider_bg.png') + ')' }"
    >
      <div
        class="slider section"
        :style="{ 'background-image': 'url(' + require('@/assets/images/landing/iphone.png') + ')' }"
      >
        <div class="box">
          <div class="main_header">
            <h1>
              <router-link
                :to="{name: 'register'}"
                class="headline"
              >
                <span class="first_line">观看您最爱的体育项目, 赢取奖励</span>
                <span class="second_line">选择8位将在本轮比赛中得分的球员, 即可赢取大奖</span>
              </router-link>
            </h1>
            <div class="quickbox">
              <router-link
                :to="{name: 'register'}"
                tag="a"
                class="button register1"
              >
                快速注册
              </router-link>
            </div>
            <a
              href="#steps"
              class="orange"
            >了解更多</a>
            <h1>
              <span class="trhird_line">超过35万玩家的信赖！</span>
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- Carrousel -->
    <div
      class="midsection"
      :style="{ 'background-image': 'url(' + require('@/assets/images/landing/carrousel_bg.png') + ')' }"
    >
      <div class="section">
        <h2>2018年奖金总额超过74,345,500元</h2>

        <div class="sliderWrapper">
          <carousel
            autoplay
            :nav="false"
            loop
            :items="4"
            :responsive="{
              0:{items:2},
              600:{items:3},
              800:{items:4}
            }"
          >
            <img
              src="@/assets/images/landing/thumb_PlayStation4.png"
              alt="PlayStation 4"
            >
            <img
              src="@/assets/images/landing/thumb_Laptop.png"
              alt="Laptop"
            >
            <img
              src="@/assets/images/landing/thumb_tv.png"
              alt="TV"
            >
            <img
              src="@/assets/images/landing/thumb_Camara.png"
              alt="Camara"
            >
          </carousel>
        </div>
      </div>
    </div>

    <!-- Bottom Section -->
    <div class="conteiner">
      <div class="section">
        <div class="row">
          <div
            id="steps"
            class="main"
          >
            <div class="step">
              <div class="stepimg">
                <router-link
                  :to="{name: 'register'}"
                  tag="a"
                  class="register1"
                >
                  <img
                    src="@/assets/images/landing/step_1.png"
                    alt=""
                  >
                </router-link>
              </div>
              <div class="steptxt">
                <router-link
                  :to="{name: 'register'}"
                  tag="a"
                  class="register1"
                >
                  <h2>马上注册, 选择你的球队</h2>
                </router-link>
                <p>您是足球球迷还是篮球的忠实观众？一旦创建账户, 选择您想要关注的体育项目, 就有机会赢取.</p>
              </div>
            </div>

            <div class="step">
              <div class="stepimg">
                <router-link
                  :to="{name: 'register'}"
                  tag="a"
                  class="register1"
                >
                  <img
                    src="@/assets/images/landing/step_2.png"
                    alt=""
                  >
                </router-link>
              </div>
              <div class="steptxt">
                <router-link
                  :to="{name: 'register'}"
                  tag="a"
                  class="register1"
                >
                  <h2>选择本轮比赛的8位球员</h2>
                </router-link>
                <p>您有机会猜中8位将在本轮比赛中得分的球员 无论球员们得分多少或有几个进球—只要这些球员达到目标, 您就离赢取大奖不远了!</p>
              </div>
            </div>

            <div class="step">
              <div class="stepimg">
                <img
                  src="@/assets/images/landing/step_3.png"
                  alt=""
                >
              </div>
              <div class="steptxt">
                <h2>开始赢取</h2>
                <p>正确猜中八位得分球员, 你将赢取一部iPhone Xs!<br>*每轮比赛的奖励都不同, 请继续关注其他豪华大奖!</p>
              </div>
            </div>
          </div>
          <div class="side">
            <h3>选择你的球队</h3>
            <img
              src="@/assets/images/landing/pick_players.png"
              width="422"
              height="541"
              alt=""
            >
          </div>
        </div>
      </div>
      <footer>
        版权所有超级8体育 备案号：辽ICP备19002132号
      </footer>
    </div>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
export default {
  name: 'CnLanding',
  components: { carousel },

}
</script>

<style scoped>
  /* Slider */
  .slick-slider
  {
    position: relative;

    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list
  {
    position: relative;

    display: block;
    overflow: hidden;

    margin: 0;
    padding: 0;
  }
  .slick-list:focus
  {
    outline: none;
  }
  .slick-list.dragging
  {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list
  {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track
  {
    position: relative;
    top: 0;
    left: 0;

    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .slick-track:before,
  .slick-track:after
  {
    display: table;

    content: '';
  }
  .slick-track:after
  {
    clear: both;
  }
  .slick-loading .slick-track
  {
    visibility: hidden;
  }

  .slick-slide
  {
    display: none;
    float: left;

    height: 100%;
    min-height: 1px;
  }
  [dir='rtl'] .slick-slide
  {
    float: right;
  }
  .slick-slide img
  {
    display: block;
  }
  .slick-slide.slick-loading img
  {
    display: none;
  }
  .slick-slide.dragging img
  {
    pointer-events: none;
  }
  .slick-initialized .slick-slide
  {
    display: block;
  }
  .slick-loading .slick-slide
  {
    visibility: hidden;
  }
  .slick-vertical .slick-slide
  {
    display: block;

    height: auto;

    border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  /*----------------------------------------*/

  body {
    margin: 0;
  }

  html {
    background-color: #13152c;
  }

  a {
    text-decoration: none;
    color: #fff;
  }

  h1 {
    margin: 0;
  }
  h2 {
    color: #fff;
    font-weight: 900;
  }

  header {
    width: 100%;
    background-color: #191c35;
    /*-background-image: linear-gradient(#191c35, #13152c);-*/
  }

  /*----------------------------------------*/

  .headline:hover {
    text-decoration: none;
    color: white;
  }

  .navbar {
    display: flex;
    justify-content: space-between;
    color: #FFF;
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 20px;
  }
  .navbar a {
    text-decoration: none;
    margin: 0;
    color: #FFF;
  }
  .navbar a:hover {
    color: #FFF;
    transition: color .5s;
  }

  .navbar-brand {
    float: left;
    display: block;
  }

  .actions {
    text-align: center;
    padding: 35px 10px;
  }

  .actions .login, .actions .sign-up {
    text-transform: capitalize;
  }
  .actions .login {
    border-radius: 30px;
    border: 3px solid #f55538;
    padding: 8px 40px;
    box-shadow: 0 1px 3px #2e2e2e;
  }

  .actions .sign-up {
    background-image: linear-gradient( #f55637, #ea2e49 );
    border-radius: 25px;
    border: 3px solid #f55538;
    padding: 8px 40px;
    box-shadow: 0 1px 3px #2e2e2e;
  }

  .navbar-navigation {
    margin: 0;
  }

  /* ------------------------- */

  .conteiner {
    width: 100%;
    background-color: #FFF;
  }
  .slideconteiner {
    width: 100%;
    background: #101122;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    height: 389px;
    background-repeat: no-repeat, no-repeat;
    background-position: calc(100% + -50px) bottom;
    background-size: auto 389px, 100% auto;
    position: relative;
    text-transform: uppercase;
  }

  /* ------------------------- */

  @media (min-width: 950px) {
    .actions {
      text-align: initial;
    }
  }
  @media (min-width: 450px) {
    .actions {
      padding: 35px 0;
    }
  }

  @media (max-width: 450px) {
    .actions .login {
      width: initial;
    }
  }

  @media (min-width: 450px) {
    .actions .sign-up {
      width: initial;
    }
  }

  @media screen and (max-width: 600px) {
    .actions .sign-up {
      padding: 8px 20px;
    }
    .actions .login {
      padding: 8px 20px;
    }
  }

  @media screen and (max-width: 420px) {
    .actions .sign-up {
      padding: 8px 18px;
      font-size: 14px;
    }
    .actions .login {
      padding: 8px 18px;
      font-size: 14px;
    }
  }
  @media screen and (max-width: 390px) {
    .actions .sign-up {
      padding: 8px 9px !important;
      font-size: 14px
    }
    .actions .login {
      padding: 8px 9px !important;
      font-size: 14px;
    }
    .actions {
      text-align: center;
      padding: 35px 0px !important;
    }

  }

  @media screen and (max-width: 380px) {
    .navbar-brand {
      display: block;
      margin: auto 10px;
    }

    .navbar-brand img {max-width: 90%; padding-top: 3%;}

    .navbar {
      padding: 0;
    }
  }

  /*----------------------------------------*/

  .slider {
    padding: 0px;
    background: #101122;
    color: white;
    max-width: 1366px;
    margin: 0 auto;
  }
  .carrousel {
    padding: 20px;
    text-align: center;
    background: #101122;
    color: white;
    max-width: 1366px;
    height: 349px;
    margin: 0 auto;
  }

  .section {
    width: 100%;
    max-width: 1366px;
    margin: 0 auto;
  }

  /*----------------------------------------*/

  .midsection li{
    list-style-type: none;
    padding: 0 10px;
  }

  .midsection {
    /* display: flex; */
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    height: 389px;
    background: center center / cover no-repeat;
    position: relative;
    text-transform: uppercase;
  }
  .midsection h2 {
    margin-top: 0;
    margin-bottom: 0;
    padding: 2rem 0;
    color: #fff;
    font-family: 'Roboto', sans-serif;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
  }

  @media only screen and (max-width: 600px) {
    .midsection {
      height: 320px;
    }
  }

  @media screen and (max-width: 600px) {
    .midsection h2 {
      font-size: 22px;
    }
  }
  @media screen and (max-width: 380px) {
    .midsection h2 {
      font-size: 18px;
    }
  }
  .slick-prev {
    width: 40px; height: 40px;
    background: url('/assets/images/landing/prev.svg') center center / cover no-repeat;
    position: absolute;
    left: .5rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;
  }
  .slick-next {
    width: 40px; height: 40px;
    background: url('/assets/images/landing/next.svg') center center / cover no-repeat;
    position: absolute;
    right: .5rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;
  }

  /*----------------------------------------*/

  .row {
    display: flex;
    flex-wrap: wrap;
  }
  .side {
    flex: 38%;
    background-color: #FFF;
    padding: 20px;
    text-align: center;
  }
  .side img {
    width: 75%;
    height: auto;
  }
  .side h3 {
    font-size: 24px;
    font-weight: bold;
    padding: 0 10px;
  }
  .main {
    flex: 62%;
    background-color: white;
    padding: 20px;
  }
  .stepimg {
    width: 35%;
    float: left;
  }
  .stepimg img {
    width: 100%;
    height: auto;
    padding: 40px 0;
  }
  .steptxt {
    width: 65%;
    padding: 8% 0;
    float: right;
    font-weight: 900;
  }
  .steptxt, h2 {
    font-size: 30px;
    color: #191c35;
    margin: 0;
  }
  .steptxt, p {
    font-size: 18px;
    color: #191c35;
  }
  .step {
    width: 100%;
    float: left;
    padding: 0;
  }

  @media screen and (max-width: 600px) {
    .steptxt {
      width: 65%;
      padding: 10px 20px;
      float: right;
    }
    .steptxt, h2 {
      font-size: 20px;
      color: #191c35;
    }
    .steptxt, p {
      font-size: 16px;
      color: #191c35;
    }
    .step {
      width: 100%;
      float: left;
      padding: 0px 0;
    }
  }

  .footer {
    background-color: #FFF;
    padding: 0 20px;
    margin: 0 auto;
    max-width: 1366px;
  }
  .footer-cta {
    max-width: 320px !important;
    height: 60px !important;
    margin: 0 auto;
  }
  .footer-cta img {
    max-width: 100%;
  }

  @media screen and (max-width: 770px) {
    .row {
      flex-direction: column;
      margin: 0 !important;
    }
  }

  @media screen and (max-width: 770px) {
    .side {
      display: none;
    }

    .stepimg img {
      padding: 20px 0;
    }
  }

  @media screen and (min-width: 500px) {
    .mobile, .image-mobile {
      display: none;
      text-align: center;
    }
    .screen, .image-desktop {
      display: block !important;
    }
    .footer-cta {
      /*width: 280px;*/
      height: 60px;
      margin: 0 auto;
    }
  }
  @media screen and (max-width: 768px) {
    .mobile, .image-mobile {
      display: block;
      text-align: center;
    }
    .screen, .image-desktop {
      display: none !important;
    }

  }

  /*----------------------------------------*/

  .orange {
    color: #f55636;
    font-size: 20px;
    padding: 0 40px;
  }

  .slider {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    height: 389px;
    background: url('/assets/images/landing/iphone.png');
    background-repeat: no-repeat, no-repeat;
    background-position: calc(100% + -100px) bottom, right bottom;
    background-size: auto 100%, 1366px auto;
    position: relative;
    text-transform: uppercase;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .slider {
      display: -ms-flexbox;
      -ms-flex-pack: start;
      -ms-flex-align: center;
      -ms-flex-direction: row;
    }
  }

  @media only screen and (max-width: 600px) {
    .slider {
      height: 330px;
    }
  }

  @media only screen and (max-width: 1136px) {
    .slider {
      background: url('/assets/images/landing/iphone.png');
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-position: 90% bottom, calc(100% + 131px) bottom, right bottom;
      background-size: auto 100%, auto 100%, 1366px auto;
    }
  }

  @media only screen and (max-width: 1034px) {
    .slider {
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-position: 650px bottom, -150px bottom, right bottom;
      background-size: auto 100%, auto 100%, 1366px auto;
    }
  }

  @media only screen and (max-width: 960px) {
    .slider {
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-position: 1250px bottom, -150px bottom, right bottom;
      background-size: auto 100%, auto 100%, 1366px auto;
    }
  }

  @media only screen and (max-width: 1920px) {
    .slideconteiner {
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-position: calc(100% + 250px) bottom;
      background-size: auto, auto 100%, 1360px auto;
    }
  }

  @media only screen and (max-width: 1440px) {
    .slideconteiner {
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-position: calc(100% + 450px) bottom;
      background-size: auto, auto 100%, 1360px auto;
    }
  }

  @media only screen and (max-width: 1024px) {
    .slideconteiner {
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-position: calc(100% + 650px) bottom;
      background-size: auto, auto 100%, 1360px auto;
    }
  }

  @media only screen and (max-width: 960px) {
    .slideconteiner {
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-position: calc(100% + 850px) bottom;
      background-size: auto, auto 100%, 1360px auto;
    }
  }

  @media only screen and (max-width: 720px) {
    .slideconteiner {
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-position: calc(100% + 1050px) bottom;
      background-size: auto, auto 100%, 1360px auto;
    }
  }
  @media only screen and (max-width: 500px) {
    .slideconteiner {
      background-repeat: no-repeat, no-repeat, no-repeat;
      background-position: calc(100% + 1050px) bottom;
      background-size: auto, auto 100%, 1360px auto;
    }

    .navbar{padding:0 5px;}
  }

  .slider .box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .slider .box {
      display: -ms-flexbox;
      -ms-flex-pack: start;
      -ms-flex-align: center;
      -ms-flex-direction: row;
    }
  }

  .slider .box .main_header {
    padding-left: 80px;
    z-index: 2;
  }

  @media only screen and (max-width: 900px) {
    .slider .box .main_header {
      text-align: center;
    }
  }

  @media only screen and (max-width: 680px) {
    .slider .box .main_header {
      padding-left: 45px;
    }
  }
  @media only screen and (max-width: 660px) {
    .slider .box .main_header {
      padding-left: 0px;
    }
  }

  .slider .box .main_header h1 {
    font-size: 28px;
  }

  @media screen and (max-width: 500px) {
    .slider .box .main_header h1 {
      font-size: 24px;
      text-align: center;
      padding: 0 20px;
    }
  }

  .slider .box .main_header h1 span {
    display: block;
    line-height: 95%;
  }

  .slider .box .main_header h1 .first_line {
    font-size: 48px;
    padding-bottom: 20px;
  }

  @media screen and (max-width: 1224px) {
    .slider .box .main_header h1 .first_line {
      font-size: 39px;}

    .slider .box .main_header h1 {
      font-size: 22px;
    }

    .slider .box .main_header {
      padding-left: 40px;
      z-index: 2;
    }
  }

  @media screen and (max-width: 600px) {
    .slider .box .main_header h1 .first_line {
      font-size: 30px;
    }
  }

  @media screen and (max-width: 960px) {
    .slider .box , .main_header , .slider .box .main_header h1
    {
      display: block;
      margin: 0 auto !important;
      width: 100% !important;
      text-align: center;}

    .slider .box .main_header {
      padding-left: 0px;}

    .slider .box .main_header h1 .first_line {
      font-size: 40px;
      text-align: center;
      width: 100% !important;
    }
  }
  @media screen and (max-width: 768px) {
    .slider .box .main_header h1 .first_line {
      font-size: 40px;
    }
  }
  .slider .box .main_header .trhird_line {
    font-size: 24px;
  }

  @media screen and (max-width: 1024px) {
    .slider .box .main_header h1 {
      font-size: 22px;
    }
  }

  @media screen and (max-width: 768px) {
    .slider .box .main_header .trhird_line{
      display: none;
    }
  }
  @media screen and (max-width: 320px) {
    .slider .box .main_header h1 .first_line {
      font-size: 30px;
    }
  }

  .slider .box .main_header h1 .second_line .orange {
    display: inline-block;
  }
  .slider .box .main_header .quickbox {
    display: inline-block;
  }
  @media screen and (max-width: 768px) {
    .slider .box .main_header .quickbox {
      display: block;
    }
  }

  .slider .box .main_header .button {
    background-image: linear-gradient( #f55637, #ea2e49 );
    border-radius: 25px;
    color: #FFF;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 282px;
    height: 52px;
    font-size: 20px;
    font-weight: bold;
    margin: 40px 0;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .slider .box .main_header .button {
      display: -ms-flexbox;
      -ms-flex-pack: center;
      -ms-flex-align: center;
      -ms-flex-direction: row;
    }
  }

  @media only screen and (max-width: 768px) {
    .slider .box .main_header .button {
      margin: 30px auto !important;

    }
  }
  @media only screen and (max-width: 620px) {
    .slider .box .main_header .button {
      margin: 20px 27%;
    }
  }
  @media only screen and (max-width: 520px) {
    .slider .box .main_header .button {
      margin: 20px 20%;
    }
  }
  @media only screen and (max-width: 450px) {
    .slider .box .main_header .button {
      margin: 20px 21%;
    }
  }
  @media only screen and (max-width: 380px) {
    .slider .box .main_header .button {
      margin: 20px 16%;
    }
  }
  @media only screen and (max-width: 320px) {
    .slider .box .main_header .button {
      margin: 20px 12%;
    }
  }

  @media only screen and (max-width: 600px) {
    .slider .box .main_header .button {
      width: 252px;
      height: 46px;
      font-size: 20px;
      align-content: center;
    }
  }
  footer {
    text-align: center;
    padding-bottom: .5rem;
  }
</style>
